import { ActivatedRouteSnapshot } from '@angular/router';

export function getParamRecursivelyFromRoute(
  route: ActivatedRouteSnapshot,
  param: string
): string | null {
  if (route.params[param]) {
    return route.params[param];
  }
  if (route.parent) {
    return getParamRecursivelyFromRoute(route.parent, param);
  }
  return null;
}

export function getDataRecursivelyFromRoute(route: ActivatedRouteSnapshot, data: string): any | null {
  if (route.data[data]) {
    return route.data[data];
  }
  if (route.parent) {
    return getDataRecursivelyFromRoute(route.parent, data);
  }
  return null;
}

export const getParentPath = (snapshot: ActivatedRouteSnapshot): string[] => {
  const segments: string[] = [];
  let current: ActivatedRouteSnapshot | null = snapshot.parent;
  // Traverse up the snapshot tree to the root
  while (current && current.url.length > 0) {
    // Add the URL segments from the current level
    segments.push(...current.url.map(segment => segment.path));
    current = current.parent;
  }
  // Reverse the array to get the path from root to parent
  return segments.reverse();
};
